import type { SiteSoh } from '@/api/fe-api/domain/entities/capacity-evaluation';

export function isSameDate(item: SiteSoh, date: Date): boolean {
  return date.getFullYear() === item.year && date.getMonth() === item.month;
}

export function combineDateAndTime(date: Date, timeString: string): Date {
  const [hours, minutes] = timeString.split(':').map(Number);

  if (isNaN(hours) || isNaN(minutes)) {
    throw new Error('Invalid time string format. Expected "HH:mm"');
  }

  const newDate = new Date(date);
  newDate.setHours(hours, minutes, 0, 0);

  return newDate;
}

export function getLocalTimezoneAbbreviation(date: Date): string {
  return date
    .toLocaleTimeString('en-us', { timeZoneName: 'short' })
    .split(' ')[2];
}

export function capitalizeFirstLetter(str: string) {
  if (!str) {
    return '';
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}
